import { render, staticRenderFns } from "./LiquidEXT.vue?vue&type=template&id=c8d9877e&scoped=true&"
import script from "./LiquidEXT.vue?vue&type=script&lang=js&"
export * from "./LiquidEXT.vue?vue&type=script&lang=js&"
import style0 from "./LiquidEXT.vue?vue&type=style&index=0&id=c8d9877e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d9877e",
  null
  
)

export default component.exports